import { apiCall, apiCallGeneric } from "../../components/service/api-service";
const tickGoApiUrl = process.env.REACT_APP_TICKGO_API_URL;
const hrNexusApiUrl = process.env.REACT_APP_HRNEXUS_API_URL;

 export const getTicketListApi = async (params) => {
  return apiCallGeneric("GET", `${tickGoApiUrl}ticket_calendar_list`, null, {
    params,
  });
};

 export const getHRNexusListApi = async (params) => {
  return apiCallGeneric("GET", `${hrNexusApiUrl}mobile/attendance`, null, {
    params,
  });
};

 export const getCallListApi = async (params) => {
  return apiCall("GET", "web/call_calendar", null, {
    params,
  });
};